
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    activeInventario: null,
    inventarios: [],
    isLoadingInventario: false,
    totalInventario: 0,

});








export const useInventariosStore = create()(
    devtools(
        storeApi
    )
)
